/* global branch */
import keyMirror from 'keymirror';
import { push } from 'connected-react-router';
import configureStore from '../store';
import routes from '../routes';
import { setNewContactLink } from '../store/ducks/branch';
import { ANDROID_DOWNLOAD_LINK, APPLE_DOWNLOAD_LINK } from './download-links';

export const BRANCH_LINK_TYPES = keyMirror({
  newContact: null,
});

export default function startBranchListener() {
  const { store } = configureStore();
  return branch.data((err, params) => {
    if (err) {
      // eslint-disable-next-line no-console
      console.error(err);
      store.dispatch(push(routes.home));
      return;
    }
    const { data_parsed: dataParsed } = params;
    if (dataParsed['+clicked_branch_link']) {
      if (dataParsed.linkType === BRANCH_LINK_TYPES.newContact) {
        const { newContactLinkType, newContactToken } = dataParsed;
        store.dispatch(setNewContactLink(newContactLinkType, newContactToken));
        store.dispatch(push(routes.answerRequest.root));
      } else {
        // eslint-disable-next-line no-console
        console.log('no branch listener', params);
        store.dispatch(push(routes.home));
      }
    }
  });
}

export function createDownloadLink(data) {
  return new Promise((resolve, reject) =>
    branch.link(
      {
        feature: 'web-download',
        channel: 'web-client',
        data: {
          ...data,
          $android_url: ANDROID_DOWNLOAD_LINK,
          $ios_url: APPLE_DOWNLOAD_LINK,
        },
      },
      (error, link) => {
        if (error) reject();
        resolve(link);
      },
    ));
}
